// @flow strict
import styled from "styled-components";

const PracticeAreasContainer = styled.div`
  margin: 0 0 50px 0;
`;

export default PracticeAreasContainer;
